export enum CreateCompanyFormFields {
    NAME = 'name',
    ACCEPT_TERMS = 'acceptTerms',
}

export enum MessageTypes {
    USER = 'USER',
    ASSISTANT = 'ASSISTANT',
}

export enum TempMessageAndChatIds {
    TEMP_MESSAGE_ID = 'TEMP_MESSAGE_ID',
    TEMP_MESSAGE_ID_1 = 'TEMP_MESSAGE_ID_1',
    TEMP_CHAT_ID = 'TEMP_CHAT_ID',
    TEMP_AWAITING_REPLY_MESSAGE_ID = 'TEMP_AWAITING_REPLY_MESSAGE_ID',
}
